import { render, staticRenderFns } from "./LogOutMenu.vue?vue&type=template&id=b072ef78&scoped=true&"
import script from "./LogOutMenu.vue?vue&type=script&lang=js&"
export * from "./LogOutMenu.vue?vue&type=script&lang=js&"
import style0 from "./LogOutMenu.vue?vue&type=style&index=0&id=b072ef78&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b072ef78",
  null
  
)

export default component.exports